<div class="login-background row">
  <div class="col-4"></div>
  <div class="card login-container col-4">
    <div class="card-header bp-card-header">
      <h3 class="login-header bp-text">Secure Log In</h3>
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="userNotFound">
      <i class="fas fa-exclamation-triangle" style="margin-right: 0.4rem;"></i>
      <span>The user name or password is incorrect. Try again or reset user/password.</span>
    </div>
    <div class="alert alert-green" role="alert" *ngIf="hasResetMsg">
      <i class="fas fa-info-circle" style="margin-right: 5px"></i>
      <span>{{resetMsg}}</span>
    </div>
    <div class="card-body">
      <form #loginForm="ngForm">
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <label for="inputUsername" class="bp-text login-label">Username</label>
            </div>
            <!--<div class="col-sm-6 text-align-right">
              <span class="txt-remember-me"><a>Remember me <i class="far fa-question-circle fa-xs txt-question"></i></a></span>
            </div>-->
          </div>
          <div class="row">
            <div class="col-sm-12">
              <input #username="ngModel" [(ngModel)]="user.username" name="username" required class="form-control" id="inputUsername">
              <div [hidden]="username.valid || username.pristine"
                   class="alert alert-danger">Please enter username</div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col-sm-12">
              <label for="exampleInputPassword1" class="bp-text login-label">Password</label>
              <input #password="ngModel" [(ngModel)]="user.password" name="password" required type="password" class="form-control" id="exampleInputPassword1">
              <div [hidden]="password.valid || password.pristine"
                   class="alert alert-danger">Please enter password</div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button type="submit" [disabled]="!loginForm.form.valid" class="btn btn-primary login-btn bp-text" (click)="onLoginClick(username.value, password.value)">LOG IN</button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <footer class="blockquote-footer" style="margin-top: 10px;">
      <div style="color: #bcbcbc; text-align: center;"><a class="forgot-pass" routerLink="/Login/ForgetUserName">Forgot Username</a> | <a routerLink="/Login/Forget">Forgot Password</a></div>
      <div class="registration-info-container container" style="margin-top: 10px;">
        <div class="row">
          <div class="registerText">Not Registered? Sign Up Now!</div>
        </div>
        <div class="row">
          <button routerLink="/Register" type="button" class="btn btn-light btn-register-now">REGISTER NOW</button>
        </div>
      </div>
    </footer>
  </div>
  <div class="col-4"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/login/login.component.html